// extracted by css-extract-rspack-plugin
export default {"Panel":"ArtifactsSidePanelOverlay-module__Panel__KJEEb","Content":"ArtifactsSidePanelOverlay-module__Content__scUUg"};